export default {
  title: 'SEO',
  subtitle:
    'Personalizați titlul și descrierea care apar în rezultatele Google și în previzualizările sociale. Lăsați gol pentru a utiliza valorile implicite.',
  fields: {
    title: {
      label: 'Titlu pagină',
      placeholder: 'ex. Forza Napoli — pizza napoletană autentică în München',
      help: 'Afișat ca titlu în rezultatele Google și pe filele browserului. Până la 255 de caractere; recomandăm 50–60 pentru cea mai bună previzualizare.',
    },
    description: {
      label: 'Descriere meta',
      placeholder: 'Scurt rezumat al restaurantului care va apărea sub titlu în rezultatele căutărilor.',
      help: 'Până la 500 de caractere; Google afișează de obicei 150–160. Evidențiați ce face restaurantul dvs. unic.',
    },
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    saved: 'Setările SEO au fost salvate',
    failed: 'Salvarea setărilor SEO a eșuat',
  },
};
